// extracted by mini-css-extract-plugin
module.exports = {"root":"Alarm_root__1hcBj","content":"Alarm_content__1w7Jn","footer":"Alarm_footer__iT7EQ","acknowledge":"Alarm_acknowledge__5Yppc"};